import { Component } from '@angular/core';
import { ClaimAdjustmentComponent } from '../claim-adjustment/claim-adjustment.component';
import { BulkClaimAdjustmentComponent } from '../bulk-claim-adjustment/bulk-claim-adjustment.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'ppl-billing-claim-adjustment',
  standalone: true,
  imports: [
    ClaimAdjustmentComponent,
    BulkClaimAdjustmentComponent,
    CommonModule,
  ],
  templateUrl: './billing-claim-adjustment.component.html',
  styleUrl: './billing-claim-adjustment.component.css',
})
export class BillingClaimAdjustmentComponent {
  showBulkAdjustment = false;
  sections = ['Claim Adjustment', 'Bulk Claim Adjustment'];
  selectedSection = 'Claim Adjustment';

  onSectionSelection(item: string) {
    this.selectedSection = item;
    if (item === 'Bulk Claim Adjustment') {
      this.showBulkAdjustment = true;
    } else {
      this.showBulkAdjustment = false;
    }
  }
}
